const storage: Storage = localStorage;

export function loadStorageItem(key: string): string | null {
  return storage.getItem(key);
}

export function saveStorageItem(key: string, value: string): string {
  storage.setItem(key, value);
  return value;
}

export function removeStorageItem(key: string): void {
  storage.removeItem(key);
}
